"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var initialState = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var currentState = initialState;

  var getState = function getState() {
    return currentState;
  };

  var update = function update(newState) {
    currentState = newState;
  };

  return {
    getState: getState,
    update: update
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/createStore.js
 ** module id = 409
 ** module chunks = 0
 **/